import { apiClient } from '@/lib/api';

export interface CommercialHeader {
  orderId: string;
  orderNumber: string;
  currency: string;
  createdAt: string;
  customer: {
    id: string;
    name: string;
    taxId: string | null;
    address: string | null;
    email: string | null;
    phone: string | null;
  } | null;
  tenant: { id: string; name: string };
}

export interface CommercialLegRow {
  id: string;
  legOrder: number;
  origin: string;
  destination: string;
  transportMode: string;
  legType: string;
  provider: { id: string; name: string } | null;
  providerCostAmount: number | null;
  customerSalePrice: number | null;
  margin: number | null;
  marginPct: number | null;
}

export interface CommercialServiceRow {
  id: string;
  legId: string;
  name: string;
  provider: { id: string; name: string } | null;
  providerCostAmount: number | null;
  customerSalePrice: number | null;
  margin: number | null;
  marginPct: number | null;
}

export interface CommercialSummary {
  header: CommercialHeader;
  legs: CommercialLegRow[];
  services: CommercialServiceRow[];
  totals: {
    totalCost: number;
    totalSale: number;
    totalMargin: number;
    totalMarginPct: number | null;
  };
}

export const commercialService = {
  async getSummary(orderId: string): Promise<CommercialSummary> {
    return apiClient.get<CommercialSummary>(
      `/api/import-tracking/orders/${orderId}/commercial-summary`
    );
  },
};
